import { AgentAction } from "./types";

export const addOrUpdateAction = (actions: AgentAction[], action: AgentAction) => {
  const existingAction = actions.find(a => action.id && a.id === action.id);
  if (existingAction) {
    if (action.type === "analysis") {
      // analysis is streamed, so we need to append to the existing action
      return [
        ...actions.filter(a => a.id !== action.id),
        { ...existingAction, content: existingAction.content + action.content },
      ];
    }
    return [...actions.filter(a => a.id !== action.id), action];
  }
  return [...actions, action];
};
